import { IS_DARK } from "./action";
const INITIAL_STATE = {
    isDark: true,
}
function useReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case IS_DARK:
            return { ...state, isDark: action.payload }
        default:
            return state;
    }
}
export default useReducer;